import HotelIndex from '@/views/hotel-index/hotel-index';
import HotelList from '@/views/hotel-list/hotel-list';
import HotelDetail from '@/views/hotel-detail/hotel-detail';
import PlanDetail from '@/views/hotel-detail/plan-detail';
import HotelBooking from '@/views/hotel-booking/hotel-booking';
import OrderDetail from '@/views/order/order-detail';
import OrderCancel from '@/views/order/order-cancel';
import Payment from '@/views/payment/hotel-payment';
import PaymentSuccess from '@/views/payment/payment-success';
import HotelMap from '@/views/map/hotel-map';
import PreviewImg from '@/views/hotel-detail/preview-imgs';
import CheckInNumber from '@/views/check-in-number/check-in-number';
import BookingFail from '@/views/booking-fail/booking-fail';
import HotelEvaluation from '@/views/evaluation/hotel-evaluation';
import EvaluationList from '@/views/evaluation/evaluation-list';
import EmptyPage from '@/views/empty-page/empty-page';

/**
 * 路由配置项
 */
export const routers = [{
  path: '/',
  redirect: '/hotel',
}, {
  path: '/hotel',
  name: 'hotel',
  component: HotelIndex,
  meta: {
    keepAlive: true,
  },
},{
  path: '/middle',
  name: 'middle-page',
  component: EmptyPage,
}, {
  path: '/hotel/list',
  name: 'hotel-list',
  component: HotelList,
}, {
  path: '/hotel/list/map',
  name: 'hotel-map',
  component: HotelMap,
}, {
  path: '/hotel/detail/:hotel_id/:start_date?/:end_date?',
  name: 'hotel-detail',
  component: HotelDetail,
}, {
  path: '/hotel/plan-detail/:plan_index', // 酒店方案详情
  name: 'plan-detail',
  component: PlanDetail,
}, {
  path: '/hotel/booking',
  name: 'hotel-booking',
  component: HotelBooking,
}, {
  path: '/hotel/order/detail/:order_id',
  name: 'hotel-order-detail',
  component: OrderDetail,
}, {
  path: '/hotel/order/cancel/:order_id/:order_status',
  name: 'hotel-order-cancel',
  component: OrderCancel,
}, {
  path: '/hotel/payment',
  name: 'hotel-payment',
  component: Payment,
}, {
  path: '/order/payment/success/:order_id',
  name: 'payment-success',
  component: PaymentSuccess,
}, {
  path: '/img/preview/:hotel_id',
  name: 'img-preview',
  component: PreviewImg,
}, {
  path: '/hotel/check-in',
  name: 'check-in',
  component: CheckInNumber,
}, {
  path: '/booking/fail',  // 预订失败页面
  name: 'booking-fail',
  component: BookingFail,
}, {
  path: '/evaluation/publish',
  name: 'hotel-evaluation',
  component: HotelEvaluation,
}, {
  path: '/evaluation/list/:hotel_id',
  name: 'evaluation-list',
  component: EvaluationList,
}];




// WEBPACK FOOTER //
// ./src/router/router.js